module.exports = __webpack_public_path__ + "static/c4-70e07bee818ae36d80424ac59ecfbd11.png";